import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { DropdownHttpService } from '@core/services/http';

export class UserManagementResolver implements Resolver {
  async resolve(): Promise<void> {
    await HttpService.getHttpRequests(DropdownHttpService).getProjectTypes();
  }
}
